import { PlatformType } from '@okletsplay/core';
import { useCallback } from 'react';
import { KNOCKOUT_TOURNAMENT_PLATFORM_TYPES } from '../constants';

export const useTournamentPlatformType = () => {
  const checkIsKnockoutEnabled = useCallback((platformType?: PlatformType) => {
    if (!platformType) {
      return false;
    }

    return KNOCKOUT_TOURNAMENT_PLATFORM_TYPES.includes(platformType);
  }, []);

  return { checkIsKnockoutEnabled };
};
